import Vue from 'vue';
import Router from 'vue-router';
/* Layout */
import Layout from '@/platform/index.vue';
import RNPLayout from '@/platform/RNPLayout.vue';
import i18n from '@/lang';
import storage from './sdk/common/Storage';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/busy',
      name: 'busy',
      component: () => import(/* webpackChunkName: "busy" */ '@/views/busy.vue')
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/home.vue')
        },
        {
          path: 'admin',
          name: 'admin',
          component: () => import('@/views/admin.vue')
        },
        {
          path: '/product/detail/:id',
          name: 'ProductDetail',
          component: () =>
            import('./views/product/productDetail.vue')
        },
        {
          path: '/product/search/:key',
          name: 'productSearch',
          component: () =>
            import('./views/product/productSearch.vue')
        },
        {
          // 个人中心
          path: '/account',
          name: 'memberCenter',
          meta: {
            requiresAuth: true // 是否进行登录验证
          },
          component: () =>
            import(
              /* webpackChunkName: "account" */ './views/account/memberCenter.vue'
            ),
          children: [
            {
            // 个人信息
              path: 'memberInfo',
              name: 'memberInfo',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
              import(
                /* webpackChunkName: "account" */ './views/account/InsMemberInfo.vue'
              )
            },
            {
              path: 'modifyPassword',
              name: 'modifyPassword',
              meta: {
                requiresAuth: true // 是否进行登录验证
              },
              component: () =>
                  import(
                    /* webpackChunkName: "account" */ './views/account/InsModifyPassword.vue'
                  )
            }
          ]
        },
        {
          path: '/account/forgetPassword',
          name: 'forgetPassword',
          component: () =>
            import(
              /* webpackChunkName: "account" */ './views/account/InsForgetPassword.vue'
            )
        },
        {
          path: '/account/login',
          name: 'login',
          component: () =>
            import(
              /* webpackChunkName: "account" */ './views/account/InsLoginN.vue'
            )
        },
        {
          path: '/health/NewCase',
          name: 'tvpNewCase',
          component: () => import(/* webpackChunkName: "main" */ '@/views/tvp/tvpNewCase.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/health/UserCenter',
          name: 'tvpUserCenter',
          component: () => import(/* webpackChunkName: "UserCenter" */ '@/views/tvp/tvpUserCenter.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/:key',
          name: 'custCmsContent',
          component: () =>
          import(
            /* webpackChunkName: "custCmsContent" */ '@/components/siteBusiness/home/CmsSwitch.vue'
          )
        }
      ]
    },
    {
      path: '/building',
      name: 'building',
      component: () => import('@/views/building.vue')
    },
    {
      path: '/regnpay',
      component: Layout,
      children: [{
        path: '',
        name: 'regnpay',
        component: () => import('@/views/regNPay/index.vue'),
        children: [{
          path: 'form/:id',
          name: 'regNPayForm',
          component: () => import('@/views/regNPay/regNPayForm.vue')
        }, {
          path: 'result/:id',
          name: 'regNPayResult',
          component: () => import('@/views/regNPay/regNPayResult.vue')
        }, {
          path: 'DeteResult/:flag',
          name: 'DeteResult',
          component: () => import('@/views/regNPay/DeteResult.vue')
        }]
      }]
    },
    {
      path: '/payment',
      component: Layout,
      children: [{
        path: 'PaySuccess/:id',
        name: 'PaySuccess',
        component: () => import('@/views/payment/paySuccess.vue')
      }, {
        path: 'PayFail/:id',
        name: 'PayFail',
        component: () => import('@/views/payment/payFail.vue')
      }]
    },
    {
      path: '/cms',
      component: Layout,
      children: [{
        path: 'content/:id',
        name: 'cmsContent',
        component: () => import('@/views/cms/content.vue')
      }, {
        path: 'catDetail/:id',
        name: 'cmsCatDetail',
        component: () => import('@/views/cms/catDetail.vue')
      }, {
        path: 'search/:key',
        name: 'search',
        component: () => import('@/views/cms/search.vue')
      }]
    },
    {
      path: '/event',
      component: Layout,
      children: [{
        path: 'list/:date',
        name: 'eventList',
        component: () => import('@/views/event/eventList.vue')
      }, {
        path: 'detail/:id',
        name: 'eventDetail',
        component: () => import('@/views/event/eventDetail.vue')
      }]
    },
    {
      path: '/photo',
      component: Layout,
      children: [{
        path: 'album',
        name: 'photoAlbum',
        component: () => import('@/views/photo/photoAlbum.vue')
      }, {
        path: 'list/:id',
        name: 'photoList',
        component: () => import('@/views/photo/photoListN.vue')
      }]
    }
  ]
});

export default router;

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { // 如果未匹配到路由
    // SEO判斷處理
    let lang = to.path.toLowerCase().match(/\/en|\/xc|\/tc/i);

    if (lang) {
      let transLang;
      switch (lang[0]) {
        case '/en':
          transLang = 'E';
          break;
        case '/xc':
          transLang = 'S';
          break;
        case '/tc':
          transLang = 'C';
          break;
      }

      i18n.locale = transLang;

      next({
        path: to.path.toLowerCase().replace(lang[0], '')
      });
    } else {
      from.name ? next({ name: from.name }) : next('/'); // 如果上級也未匹配到路由則跳轉首頁，如果上級能匹配到則轉上級路由
    }
  }

  setTimeout(function () {
    if (to.path === '/account/login') {
      if (storage.get('isLogin')) {
        next({ path: '/home' });
      }
      next();
    } else {
      if (to.matched.some(record => record.meta.requiresAuth) && !storage.get('isLogin')) {
        // router.push({ path: '/account/login' });
        next({
          path: '/account/login',
          query: {
            returnurl: to.path
          }
        });
      } else if (to.matched.some(record => record.meta.requiresAuth) && storage.get('timeout') && storage.get('timeout') < new Date().getTime()) {
        Vue.prototype.$Login(function () { next(); });
      } else {
        next();
      }
    }
  }, 200);

  if (from.name) {
    Vue.prototype.$ShowLayer();
    next();
    setTimeout(() => {
      Vue.prototype.$HiddenLayer();
    }, 500);
  } else {
    setTimeout(function () {
      next();
    }, 200);
  }
});
